import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  autoComplete: {
    "& .MuiFormControl-root": {
      border: "1px thin rgba(0, 0, 0, 0.4)",
      minWidth: "100%",
      marginTop: theme.spacing(1),
    },
    "& .MuiAutocomplete-inputRoot": {
      padding: "unset",
    },
    "& .Mui-focused fieldset": {
      border: "none",
    },
    "& .MuiOutlinedInput-root": {
      boxShadow: "inset 1px 2px 2px rgba(0, 0, 0, 0.4)",
      height: theme.spacing(5),
      borderRadius: 0,
      textTransform: "uppercase",
    },
    "& .MuiAutocomplete-endAdornment": {
      display: "flex",
      backgroundColor: "rgba(0, 0, 0, 0.1)",
      marginTop: theme.spacing(-0.5),
      marginRight: theme.spacing(-1),
      height: theme.spacing(4.6),
      width: "30px",
      "& .MuiAutocomplete-popupIndicator": {
        order: 2,
      },
      "& .MuiAutocomplete-clearIndicator": {
        order: 1,
        marginLeft: theme.spacing(-3.2),
      },
    },
  },
  label: {
    color: "#000",
  },
  error: {
    color: "red",
  },
  dropDown: {
    textTransform: "uppercase",
  },
}));

export default useStyles;
